import moment from 'moment'
import mock from '@/@fake-db/mock'
import { paginateArray, sortCompare } from '@/@fake-db/utils'

/* eslint-disable global-require */
const data = {
  events: [
    {
      id: 1,
      name: 'Принцесса цирка',
      datetime: moment('21.01.2022 20:00:00', 'DD.MM.YYYY HH:mm:ss'),
      type: 'Цирк',
      timeLength: 80,
      ageLimit: 0,
      promoter: {
        name: 'Росгосцирк',
      },
      ticketFund: 'Общедоступный',
      ticketProvider: {
        name: 'Росгосцирк',
      },
      ticketBook: 351,
      tickets: {
        total: 495,
        sections: [
          {
            total: 300,
            price: 300,
          },
          {
            total: 100,
            price: 400,
          },
          {
            total: 95,
            price: 1000,
          },
        ],
      },
      place: {
        id: 1002,
        name: 'Саратовский государственный цирк имени братьев Никитиных',
        rows: 16,
        maxSeats: 100,
        sides: [
          'Левая сторона',
          'Правая сторона',
        ],
        sectors: [
          '1 сектор',
          '2 сектор',
          '3 сектор',
          '4 сектор',
        ],
        map: '/schema_sample.svg',
      },
    },
    {
      id: 2,
      name: 'Самарский цирк',
      datetime: moment('22.01.2022 19:00:00', 'DD.MM.YYYY HH:mm:ss'),
      type: 'Цирк',
      timeLength: 120,
      ageLimit: 7,
      promoter: {
        name: 'Росгосцирк',
      },
      ticketFund: 'Общедоступный',
      ticketProvider: {
        name: 'Росгосцирк',
      },
      ticketBook: 360,
      tickets: {
        total: 495,
        sections: [
          {
            total: 300,
            price: 300,
          },
          {
            total: 100,
            price: 400,
          },
          {
            total: 95,
            price: 1000,
          },
        ],
      },
      place: {
        id: 1001,
        name: 'Самарский государственный цирк имени братьев Запашных',
        rows: 16,
        maxSeats: 100,
        sides: [
          'Левая сторона',
          'Правая сторона',
        ],
        sectors: [
          '1 сектор',
          '2 сектор',
          '3 сектор',
          '4 сектор',
        ],
        map: '/schema_sample.svg',
      },
    },
    {
      id: 3,
      name: 'Мадонна',
      datetime: moment('25.01.2022 21:00:00', 'DD.MM.YYYY HH:mm:ss'),
      type: 'Концерт',
      timeLength: 90,
      ageLimit: 18,
      promoter: {
        name: 'Росгосцирк',
      },
      ticketFund: 'Общедоступный',
      ticketProvider: {
        name: 'Росгосцирк',
      },
      ticketBook: 100,
      tickets: {
        total: 495,
        sections: [
          {
            total: 300,
            price: 300,
          },
          {
            total: 100,
            price: 400,
          },
          {
            total: 95,
            price: 1000,
          },
        ],
      },
      place: {
        id: 1000,
        name: 'МосГорЦирк',
        rows: 16,
        maxSeats: 100,
        sides: [
          'Левая сторона',
          'Правая сторона',
        ],
        sectors: [
          '1 сектор',
          '2 сектор',
          '3 сектор',
          '4 сектор',
        ],
        map: '/schema_sample.svg',
      },
    },
  ],
}
/* eslint-enable */

// ------------------------------------------------
// GET: Return Users
// ------------------------------------------------
mock.onGet('/apps/event/events').reply(config => {
  // eslint-disable-next-line object-curly-newline
  const {
    q = '',
    perPage = 10,
    page = 1,
    sortBy = 'id',
    sortDesc = false,
    sortByDate = false,
    filterPlace = false,
    filterType = false,
  } = config.params
  /* eslint-enable */

  function filterFunction(event) {
    if (filterPlace) {
      if (filterPlace === event.place.name) {
        return true
      }
      return false
    }
    if (filterType) {
      if (filterType === event.type) {
        return true
      }
      return false
    }
    if (sortByDate) {
      if (sortByDate === event.datetime.format('DD/MM/YYYY')) {
        return true
      }
      return false
    }
    return true
  }
  // const queryLowered = q.toLowerCase()
  const filteredData = data.events.filter(filterFunction)
  /* eslint-enable  */

  const sortedData = filteredData.sort(sortCompare(sortBy))
  if (sortDesc) sortedData.reverse()

  return [
    200,
    {
      events: paginateArray(sortedData, perPage, page),
      meta: {
        total: filteredData.length,
      },
    },
  ]
})

mock.onGet('/apps/event/book').reply(config => {
  const bookResult = {
    result: 1,
    id: Math.floor(Math.random() * (0 - 100000) + 100000),
    m: config.m,
    r: config.r,
    price: Math.floor(Math.random() * (100 - 10000) + 10000),
    seatDescription: 'Левая сторона 2 сектор',
  }

  return [200, bookResult]
})

mock.onGet(/\/apps\/event\/\d+/).reply(config => {
  // Get event id from URL
  let eventId = config.url.substring(config.url.lastIndexOf('/') + 1)

  // Convert Id to number
  eventId = Number(eventId)

  const eventIndex = data.events.findIndex(e => e.id === eventId)
  const event = data.events[eventIndex]

  if (event) return [200, event]
  return [404]
})
